import styled from 'styled-components'

export const Container = styled.div`
  margin: 8px 0;
  position: relative;
  text-align: left;

  .headerTitle{
        
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 1.1;
    text-transform: uppercase;
  text-align: left;

    color: #000000;

    margin-top: 1em;
    margin-bottom: 1em;
  }
  p{
      
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
  text-align: left;
  }

  
  
  .button-ar {
    overflow: visible;
    margin-top: 20px;
    display: block;
    width: 100%;
    text-decoration: none;

    @media (min-width: 1000px) {
      display: none;
    }
    .button{
      overflow: visible;
      background: #fff;
      color: #000;
      margin: 0;
      width: 100%;
    }
    .button::after, .button::before {
      display: none;
    }
    .spin{
      display: none;
    }
    .button-ar__image {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translateY(-45%);
      height: 160%;
      width: auto;
    }
  }
  .button {
    box-sizing: border-box;
    display: inline-flex;
    min-height: 40px;
    width: 150px;
    border: 2px solid #000;
    margin: 20px 20px 20px 20px;
    color: rgba(239, 239, 239, 1);
    /* color: #b99777; */
    text-transform: uppercase;
    text-decoration: none;
    font-size: 0.8em;
    letter-spacing: 1.5px;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    background-color: rgba(0, 0, 0, 1);
    position: relative;

    
    /* background-color: rgba(239, 239, 239, 0.8); */
  }
`

export const style = {}

export default style
